import * as React from "react"

export default function SettingsOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.834 4.622v6.755L8 14.755l-5.833-3.378V4.622L8 1.244l5.834 3.378zM8 5.834A2.167 2.167 0 0110.166 8l-.01.214A2.167 2.167 0 018 10.166l-.214-.01A2.168 2.168 0 015.834 8l.01-.214a2.167 2.167 0 011.942-1.942L8 5.834zm0 .333a1.833 1.833 0 100 3.666 1.833 1.833 0 000-3.667zm5.5-1.353l-.25-.145-5-2.894L8 1.629l-.25.146-5 2.894-.25.145v6.372l.25.145 5 2.894.25.146.25-.146 5-2.894.25-.145V4.814z"
        stroke={props.fill}
      />
    </svg>
  )
}
